import { render, staticRenderFns } from "./entranceGuardAlarm.vue?vue&type=template&id=1dffced0"
import script from "./entranceGuardAlarm.vue?vue&type=script&lang=js"
export * from "./entranceGuardAlarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports